<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="-0.25 0 93 93"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="m 53.45127,21.185355 -15.3,7.1 7,14.9 18.3,-8.5 c -2.7,-4.9 -6.1,-9.5 -10,-13.5 z m 0.5,-2.5 13.6,-6.3 c -8.7,-5.8 -19.4,-7.5 -30.1,-4.8 3.9,1.7 10.2,5.1 16.5,11.1 z m -16.6,7.7 14.5,-6.8 c -4.6,-4.3 -9.8,-7.8 -15.6,-10.3 -0.9,-0.4 -1.6,-0.7 -2.1,-0.9 -1.5,0.5 -2.9,1.1 -4.4,1.7 z m 33.2,32.8 -14.7,6.9 7.7,16.5 c 1.6,-0.8 3.2,-1.7 4.6,-2.6 0.1,-0.5 0.3,-1 0.5,-1.6 1.7,-6.3 2.3,-12.8 1.9,-19.2 z m 15.1,-7.1 -13.1,6.1 c 0.7,8.5 -0.5,15.4 -1.6,19.7 8.1,-6.4 13.3,-15.8 14.7,-25.8 z m -13.3,3.9 13.6,-6.4 c 0.4,-5.8 -0.4,-11.8 -2.6,-17.6 l -15.4,7.2 c 2.4,6 3.8,11.6 4.4,16.8 z m -17.4,8.1 15.4,-7.2 c -0.6,-5.8 -2.1,-11.4 -4.3,-16.8 l -18.3,8.5 z m -35.5,-29.4 c -0.5,-6.6 0.2,-13.2 2,-19.5 -8.1,6.4 -13.3000005,15.6 -14.8000005,25.5 z m 4.3,18.5 c -2.1,-5.2 -3.5,-10.7 -4.1,-16.3 l -13.3000005,6.2 c -0.5,5.7 0.2,11.5 2.3,17.1 z m 12.5,19.6 c -4,-4.2 -7.3,-9 -10,-14.1 l -15.1,7.1 -5.7000005,2.6 c -0.4,-0.7 -0.8,-1.5 -1.1,-2.3 -10.8,-23.1 -0.8,-50.6 22.3000005,-61.4 20.1,-9.4 42.4,-4.4 55.2,12.7 l -5.7,2.8 c -2,-2.5 -4.2,-4.7 -6.7,-6.5 l -13.9,6.5 c 3.5,3.6 6.9,8.1 9.9,13.6 l 19.1,-8.9 2,-0.9 c 0.6,1 1.1,2 1.6,3 10.8,23.1 0.8,50.6 -22.3,61.4 -20.2,9.4 -42.4,4.5 -55.2,-12.7 l 5.7,-2.9 c 1.9,2.4 4,4.5 6.3,6.3 z m 17.8,13.1 c -6,-2.8 -11.5,-6.8 -16.3,-11.5 l -13.4,6.3 c 8.6,5.8 19.1,7.6 29.7,5.2 z m -14.2,-12.4 c 4.6,4.5 10,8.2 15.9,10.9 0.6,0.3 1.1,0.5 1.6,0.7 1.4,-0.4 2.9,-1 4.3,-1.6 l -7.7,-16.5 z m -11.7,-15.7 c 2.7,5.1 6.1,9.9 10.1,14.1 l 14.8,-6.9 -7.2,-15.4 z m -6.4,-21.8 c 0.5,5.6 1.9,11.1 4,16.3 l 17.6,-8.2 -7,-14.9 z m 2.6,-22.8 c -0.2,0.5 -0.4,1.2 -0.7,2.1 -1.8,6 -2.5,12.3 -2.1,18.5 l 13.9,-6.5 -7.5,-16.2 c -1.3,0.7 -2.5,1.3 -3.6,2.1 z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-prosegur",
  components: {},
})
export class IconProsegur extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconProsegur;
</script>
